import React, { useState } from "react";

const SecModule = React.memo(({ dataStore }) => {
  const [selectedCategory, setSelectedCategory] = useState(
    dataStore.length > 0 ? dataStore[0].name : "TDS Dashboard"
  );

  return (
    <div className="">
      <div className="sm:grid grid-cols-5 rounded-2xl shadow-2xl relative isolate overflow-hidden bg-white">
        <div class="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.indigo.100),white)] opacity-20"></div>
        <div class="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-white shadow-xl shadow-orange-600/10 ring-1 ring-indigo-50 sm:mr-28 lg:mr-0 xl:mr-16 xl:origin-center"></div>
        <div className="col-span-1 flex flex-col items-center sm:items-end justify-center space-y-2 py-3 sm:py-0 bg-blue-50 bg-opacity-70">
          {dataStore.map((item, index) => (
            <div
              key={index}
              className={`py-2 w-full bg-[#ccdffd] tracking-wide text-black font-bold text-lg border-b border-[#000000] 
            hover:border-[#b5d0ff] hover:bg-[#b5d0ff] active:bg-[#ffffff] hover:text-black duration-200
            text-center px-6 inline-flex items-center justify-center cursor-pointer 
            ${selectedCategory === item.name ? "bg-blue-500" : ""}`}
              style={{
                backgroundColor:
                  selectedCategory === item.name ? "#ccdffd" : "#ffffff",
                color: selectedCategory === item.name ? "#000000" : "",
              }}
              onClick={() => setSelectedCategory(item.name)}
            >
              {item.name}
            </div>
          ))}
        </div>
        <div className="col-span-4 relative bg-white overflow-hidden">
          <div className="item active items-center sm:grid grid-cols-1">
            <div className="sm:px-2 sm:py-2 p-3 sm:flex justify-center">
              {dataStore.map((item, index) => (
                <img
                  src={item.back}
                  className="rounded-2xl shadow-xl sm:w-[100%]"
                  style={{
                    display: selectedCategory === item.name ? "block" : "none",
                  }}
                  key={index}
                  alt=""
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SecModule;
